export function dropExtension(phone) {
  if (typeof phone !== "string") return;

  return phone.split("x")[0];
}

export function phoneProps({ phone, type, id }) {
  const extensionlessPhone = dropExtension(phone);
  return {
    dataOutboundType: type,
    dataOutboundId: id,
    dataOutboundNumber: extensionlessPhone,
    href: `tel:${extensionlessPhone}`
  };
}

export function phoneTemplateProps(args) {
  const props = phoneProps(args);

  return {
    "data-outbound-type": props.dataOutboundType,
    "data-outbound-id": props.dataOutboundId,
    "data-outbound-number": props.dataOutboundNumber,
    href: props.href
  };
}

export function phoneTemplatePropsToString(args) {
  const props = phoneTemplateProps(args);

  return Object.keys(props)
    .map(p => `${p}="${props[p]}"`)
    .join(" ");
}
